import fetch from 'isomorphic-fetch';
import * as ActionTypes from './types/PlacesActionTypes';

export function requestAddress() {
  return {
    type: ActionTypes.REQUEST_ADDRESS
  };
}

export function receiveAddress(response, overrideName) {
  return {
    type: ActionTypes.RECEIVE_ADDRESS,
    payload: response,
    overrideName
  };
}

export function resetAddress() {
  return {
    type: ActionTypes.RESET_ADDRESS,
  };
}

export function getPlaceDetails(placeId, address, overrideName) {
  return (dispatch) => {
    dispatch(requestAddress());
    return fetch('/web-api/v1/location/details',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(Object.assign({}, { google_place_id: placeId, address }))
      })
      .then(response => response.json())
      .then(json => dispatch(receiveAddress(json, overrideName)));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/PlacesActions.js
 **/